import React from 'react';
import Header from '../components/Header';
import HeroBanner from '../components/HeroBanner';
import InfoSection from '../components/InfoSection';
import ContactSection from '../components/ContactSection';
import BlogSection from '../components/BlogSection';
import Chatbot from '../components/Chatbot';

const PublicSite = () => {
  return (
    <div className="bg-[#020617] text-slate-100 noise-bg">
      <Header />
      <HeroBanner />
      <InfoSection />
      <BlogSection />
      <ContactSection />
      <Chatbot />
    </div>
  );
};

export default PublicSite;
